// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"381":"60f8eb60","426":"e860fc40","611":"56dee1cb","712":"56dee1cb"}[chunkId] + ".css";
};